module.exports = __webpack_public_path__ + "img/11.674a1fec.jpg";